"use strict"

import "../extend/date.js";
import { LabeledTextInput } from "../labeledTextInput.js";
import {groupClassNames} from '../util.js';
import {ModalShowTimetableItem} from "../modals/modalShowTimetableItem.js";
import {ModalShowInfo} from "../modals/modalShowInfo.js";
import { ModalSelectTimeFrame } from "../modals/modalSelectTimeFrame.js";
import {DataView} from '../dataview.js';
import { ModalMenu } from "../modals/modalMenu.js";
import { ModalEditPupilNote } from "../modals/modalEditPupilNote.js";
import { ModalEditSmartphoneViolationNote } from "../modals/modalEditSmartphoneNote.js";
import { sortTeacherByShort, sortPupilByClassAndName, sortClass, sortRoom } from "../util.js";
import { formatLink } from "../util.js";
import { ClassNote } from "../classNote.js";

export class Timetable {

   constructor(app) {
      this.app = app;
      this.dm = app.dm;

      this.tab = document.querySelector('.main-item[tab-name="timetable"]');
      this.table = this.tab.querySelector('.timetable');
      this.title = this.tab.querySelector('.title .title-content');
      this.elResults = this.tab.querySelector('.search-results');
      this.elMain = this.tab.querySelector('.main-content');
      this.elInfo = this.tab.querySelector('.main-content .info');
      this.hourRows  = [0, 3, 4, 6, 7, 9, 10, 12, 13, 14, 15, 16, 17];
      this.breakRows = [2, 5, 8, 11];

      const cb = (value) => {
         this.searchTimetable(value);
      };

      this.txtSearch = new LabeledTextInput('.main-item.timetable .txt-search', { labelText: 'Suche'/*, onChanging: cb*/ });
      document.querySelector('.main-item.timetable .txt-search').oninput = event => this.searchTimetable(event.target.value);

      this.tab.querySelector('.btn-my').addEventListener('click', event => {
         this.loadTimetable(this.user);
      });

      this.tab.querySelector('.btn-prev').addEventListener('click', event => {
         if (!event.target.classList.contains('disabled')) this.loadNeighbour('prev');
      });

      this.tab.querySelector('.btn-next').addEventListener('click', event => {
         if (!event.target.classList.contains('disabled')) this.loadNeighbour('next');
      });


   }

   refresh() {
      this.selectCurrentHour();
   }

   selectCurrentHour() {

      this.table.querySelectorAll('.current').forEach(item => item.classList.remove('current'));

      if (!this.timeFrames) return;

      const currentDate = new Date();
      let currentTimeString = currentDate.getHours().pad(2, '0') + ':' + currentDate.getMinutes().pad(2, '0');

      for (let i=0; i<this.timeFrames.length; ++i) {
         if (currentTimeString >= this.timeFrames[i].normStart && currentTimeString <= this.timeFrames[i].normEnd) {
            const elCell = this.table.querySelector('.sel-' + (currentDate.getWeekday() + 1) + '-' + (i + 1));
            if (elCell) elCell.classList.add('current');
         }
      }

      for (let i=0; i<this.timeFramesBreak.length; ++i) {
         if (currentTimeString >= this.timeFramesBreak[i].start && currentTimeString <= this.timeFramesBreak[i].end) {
            const elCell = this.table.querySelector('.sel-b-' + (currentDate.getWeekday() + 1) + '-' + i);
            if (elCell) elCell.classList.add('current');
         }
      }

   }

   showSearchResults(show) {
      this.elResults.style.display = show ? 'block' : 'none';
      this.elMain.style.display = show ? 'none' : 'flex';
   }

   searchTimetable(searchValue) {

      this.elResults.empty();

      // leeres Suche: Stundenplan wieder anzeigen
      if (searchValue.length === 0) {
         this.showSearchResults(false);
      }

      // Damit eine Suche durchgeführt werden muss, muss der Suchstring entweder länger als 2 Zeichen sein oder mit einer Zahl beginnen
      if (searchValue.length < 2 && searchValue.search(/^ *\d/) === -1) return;

      searchValue = searchValue.toUpperCase();

      const users = this.dm.getUsers();
      const classes = this.dm.getClasses();
      const rooms   = this.dm.getRooms();
      const courses = this.dm.getCourses();

      let results = [];

      let re = new RegExp(searchValue, 'i');

      for (const userId in users) {
         const user = users[userId];
         if (user.short.toUpperCase() === searchValue) {
            let result = Object.extend(true, user, { sortOrder: 1 });
            results.push(result);
         }
         else if (user.lastName.search(re) !== -1) {
            let result = Object.extend(true, user, { sortOrder: 2 });
            results.push(result);
         }
         else if (user.firstName.search(re) !== -1) {
            let result = Object.extend(true, user, { sortOrder: 3 });
            results.push(result);
         }
      }

      for (const classId in classes) {
         const cls = classes[classId];
         if (cls.name.search(re) !== -1) {
            results.push({type: 'class', sortOrder: 1, id: cls.id, name: cls.name });
         }
      }

      for (const roomId in rooms) {
         const room = rooms[roomId];
         if (room.short.search(re) !== -1) {
            let result = Object.extend(true, room, { type: 'room', sortOrder: 3 });
            results.push(result);
         }
      }

      for (const course of courses) {
         if (['11', '12', '13'].includes(course.classNames) && course.short.search(re) !== -1) {
            let result = Object.extend(true, course, { type: 'course', sortOrder: 1 });
            results.push(result);
         }
      }

      // Wenn nur ein Ergebnis vorliegt: direkt dieses laden
      if (results.length === 0) {
         this.elResults.innerHTML = "Keine Treffer";
      }

      if (results.length === 1) {
         this.loadTimetable(results[0]);
      }
      else {
         this.showSearchResults(true);
         results.sort((a,b) => { return a.sortOrder - b.sortOrder; } );

         for (const result of results) {
            let elResult = this.elResults.createElement('div', 'search-result ' + result.type);
            if (result.type === 'teacher') {
               elResult.innerHTML = '<div class="type teacher">L</div>' + result.lastName + (result.firstName !== '' ? ', ' + result.firstName : '') + ` (${result.short})`;
            }
            else if (result.type === 'pupil') {
               const cls = this.dm.getClass(result.classId);
               const clsString = cls.year < 11 ? cls.name : cls.name + ', ' + this.app.dm.getUser(result.tutorId);
               //console.log(clsString);

               elResult.innerHTML = '<div class="type pupil">S</div>' + `${result.lastName}, ${result.firstName} (${cls.name})`;
            }
            else if (result.type === 'class') {
               elResult.innerHTML = '<div class="type class">K</div>' + result.name;
            }
            else if (result.type === 'room') {
               elResult.innerHTML = '<div class="type room">R</div>' + result.short + (result.description.length > 0 ? ' (' + result.description + ')' : '');
            }
            else if (result.type === 'course') {
               elResult.innerHTML = '<div class="type course">K</div>' + result.classNames + result.short + ` (${result.teachers.map(id => this.dm.getUser(id).short).join(',')})`;
            }

            elResult.addEventListener('click', (event) => {
               this.loadTimetable(result);
               event.stopPropagation();
            });


         }

      }

   }

   loadNeighbour(dir) {

      let index = this.result.list.findIndex(item => item.id === this.result.id);
      if (index === -1) return;

      if (dir === 'prev') {
         index = index === 0 ? this.result.list.length-1 : index - 1;
      }
      else if (dir === 'next') {
         index = index === this.result.list.length-1 ? 0 : index+1;
      }

      const item = this.result.list[index];
      item.type = this.result.type;

      this.loadTimetable(item);

   }

   loadInfo(result) {
      this.elInfo.empty();

      if (result.type === 'class') {
         const cls = this.dm.getClass(result.id);
         this.elInfo.innerHTML += `
            <div class="fw-bold">Schüler</div>
            <div class="list-pupils"></div>
            <div class="flat-button btn-copy-pupil-emails mb-10">Schüler-Emailadressen kopieren</div>
            <div class="fw-bold">Lehrer</div>
            <div class="list-teachers"></div>
            <div class="flat-button btn-copy-teacher-emails mb-10">Lehrer-Emailadressen kopieren</div>
         `;

         const pupils   = cls.pupils.map(id => this.dm.getPupil(id));
         let listPupilsSettings = {
            columns: [
               { title: 'Nachname', data: 'lastName', sort: { index: 1, dir: 1 }, css: { height: '1.5rem' } },
               { title: 'Vorname', data: 'firstName', sort: { index: 2, dir: 1 } },
               { title: 'Email-Adresse', data: 'email', sort: { index: 3, dir: 1 } }
            ]
         };
         const listPupils = new DataView(this.elInfo.querySelector('.list-pupils'));
         listPupils.load(pupils, listPupilsSettings);

         let courseTeachers = {};
         this.dm.getCourses()
         .filter(course => course.classes.includes(cls.id))
         .map(course => {
            for (const teacherId of course.teachers) {
               if (!courseTeachers.hasOwnProperty(teacherId)) courseTeachers[teacherId] = { teacher: this.dm.getUser(teacherId), courses: [] };
               courseTeachers[teacherId].courses.push(course);
            }
         })

         courseTeachers = Object.values(courseTeachers).map(item => ({ short: item.teacher.short, subjects: item.courses.map(c => c.short).join(', '), email: item.teacher.email }));
         let listTeachersSettings = {
            columns: [
               { title: 'Kürzel', data: 'short', sort: { index: 1, dir: 1 }, css: { height: '1.5rem' } },
               { title: 'Fächer', data: 'subjects', sort: { index: 2, dir: 1 } },
               { title: 'Email-Adresse', data: 'email', sort: { index: 3, dir: 1 } }
            ]
         };
         const listTeachers = new DataView(this.elInfo.querySelector('.list-teachers'));
         listTeachers.load(courseTeachers, listTeachersSettings);

         this.elInfo.querySelector('.btn-copy-pupil-emails').onclick = () => {
            navigator.clipboard.writeText(pupils.map(pupil => pupil.email).join(','));
         }

         this.elInfo.querySelector('.btn-copy-teacher-emails').onclick = () => {
            navigator.clipboard.writeText(courseTeachers.map(teacher => teacher.email).join(','));
         }

         //cls.teachers.map(teacher => this.dm.getUser(teacher.id));




      }


   }

   async loadPupilNotes(elItems, pupilId) {

      const items = await ClassNote.loadPupilNotesByPupil(this.dm, pupilId);
      elItems.empty();

      for (let item of items) {
         try {

            let note = formatLink(item.note);

            let elItem = null;
            if (item.type === 'pupilNote' || item.type === 'smartphoneViolation') {
               const pupil = this.user.type === 'teacher' ? this.app.dm.getUser(item.pupilId) : this.user;
               elItem = elItems.createElement('div', 'class-note-item');
               elItem.innerHTML = `
                  <div class="content">
                     <span class="date">${Date.simplifyDatePeriod(item.dateFrom, item.dateTo)}</span>
                     ${item.type === 'smartphoneViolation' ? '📱 (Handy-Verstoß) ' : ''}<span class="message">${note}</span>
                     <span class="creator">${this.dm.getUser(item.creatorId).short}</span>
                  </div>`;
            }

            if (item.syncStatus === 'delete') elItem.classList.add('deleted');

            if (this.user.hasPermission('classreg', 'edit')) {
               elItem.onclick = (event) => {
                  if (item.type === 'pupilNote') new ModalEditPupilNote(this.app, item, () => this.loadPupilNotes(elItems, pupilId));
                  else if (item.type === 'smartphoneViolation') new ModalEditSmartphoneViolationNote(this.app, item, () => this.loadPupilNotes(elItems, pupilId));
                  event.stopPropagation();
               }
               elItem.querySelectorAll('a').forEach(elA => elA.onclick = (e) => {
                  e.stopPropagation();
               });   
            }

         }
         catch (e) {
            logger.error(e);
            toast.alert("Eine Klassennotiz konnte nicht geladen werden: " + e, { duration: 8000 });
         }
      }

   }

   loadTimetable(result) {
      this.result = result;

      let timetable = [];

      let prevNext = true;

      this.elMain.setAttribute('result-type', result.type);

      if (result.type === 'teacher') {
         result.list = Object.values(this.dm.getTeachers()).filter(teacher => teacher.short[0] !== '*');
         result.list.sort(sortTeacherByShort);
         timetable = this.dm.getTimetableByTeacher(result.id);
         this.title.innerHTML = result.lastName + (result.firstName !== '' ? ', ' + result.firstName : '') + ` (${result.short})`;
      }
      else if (result.type === 'pupil') {
         result.list = Object.values(this.dm.getPupils());
         result.list.sort(sortPupilByClassAndName);
         timetable = this.dm.getTimetableByPupil(result.id);
         const cls = '(' + this.dm.getClass(result.classId).name + (result.tutorId ? `, ${this.dm.getUser(result.tutorId).short}` : '') + ')';
         this.title.innerHTML = result.lastName + (result.firstName !== '' ? ', ' + result.firstName : '') + ` ${cls}<br>${result.short}`;
         if (this.user.type === "teacher") this.loadPupilNotes(this.elMain.querySelector('.notes .items'), result.id);

         if (this.user.hasPermission('classreg', 'edit')) {
            this.elMain.querySelector('.notes').onclick = (event) => {
               event.stopPropagation();
               const btnPos = this.elMain.querySelector('.btn-add-pupil-note').getBoundingClientRect();
               const isoDate = (new Date()).isoDate();

               const note = { pupilId: result.id, dateFrom: isoDate, dateTo: isoDate, creatorId: this.user.id };

               new ModalMenu({
                  items: [
                     { label: 'Schüler-Anmerkung', onSelect: () => new ModalEditPupilNote(this.app, note, () => this.loadTimetable(result) ) },
                     { label: '📱 Handy-Verstoß', onSelect: () => new ModalEditSmartphoneViolationNote(this.app, note, () => this.loadTimetable(result)) },
                  ],
                  position: { corner: 'top right', offset: { x: document.body.getBoundingClientRect().right - btnPos.left, y: btnPos.top } }
               });
            };
         }
         else {
            this.elMain.querySelector('.notes .icon-plus').style.display = 'none';
         }

      }
      else if (result.type === 'class') {
         result.list = Object.values(this.dm.getClasses());
         result.list.sort(sortClass);
         const cls = this.dm.getClass(result.id);
         timetable = this.dm.getTimetableByClass(result.id);
         this.title.innerHTML = result.name + (cls.formTeachers.length > 0 ? ' (Klassenleitung: ' + cls.formTeachers.map((teacherId) => { return this.dm.getUser(teacherId).lastName}).join(', ') + ')' : '');
      }
      else if (result.type === 'room') {
         result.list = Object.values(this.dm.getRooms());
         result.list.sort(sortRoom);
         timetable = this.dm.getTimetableByRoom(result.id);
         this.title.innerHTML = result.short + (result.description ? ' (' + result.description + ')' : '');
      }
      else if (result.type === 'course') {
         prevNext = false;
         timetable = this.dm.getTimetableByCourse(result.id);
         this.title.innerHTML = result.classNames + result.short + ` (${result.teachers.map(id => this.dm.getUser(id).short).join(',')})`;
      }

      this.tab.querySelectorAll('.btn-prev, .btn-next').forEach(elBtn => {
         if (prevNext) elBtn.classList.remove('disabled');
         else elBtn.classList.add('disabled');
      });

      this.loadInfo(result);

      this.showSearchResults(false);

      this.table.empty();
      this.table.classList.add(this.user.type);

      const weekNumber = new Date().getWeekNumber();
      const dayNames = ['W' + weekNumber, 'Mo', 'Di', 'Mi', 'Do', 'Fr'];
      
      for (let i=0; i<dayNames.length; ++i) {
         const elDay = this.table.createElement('div', 'timetable-cell day-name');
         elDay.setStyles({ gridArea: `1 / ${i+1}` });
         elDay.innerHTML = '<div class="center-h">' + dayNames[i] + '</div>';
      }

      /*
      this.timeFrames = [
         { start: '8:05', end: '8:50' },
         { start: '8:50', end: '9:35' },
         { start: '9:50', end: '10:35' },
         { start: '10:40', end: '11:25' },
         { start: '11:35', end: '12:20' },
         { start: '12:25', end: '13:10' }
      ];

      this.timeFramesPM = [
         { start: '13:35', end: '14:20' },
         { start: '14:20', end: '15:05' },
         { start: '15:05', end: '15:50' },
         { start: '15:50', end: '16:35' }
      ];

      this.timeFramesBreak = [
         { start: '08:00', end: '08:05' },
         { start: '09:35', end: '09:50' },
         { start: '11:25', end: '11:35' },
         { start: '13:10', end: '13:25' }
      ]
      */
      

      const timeFrames = this.dm.getTimeFrames('regular');
      this.timeFrames = timeFrames.am;
      this.timeFramesBreak = timeFrames.break;

      if (this.user.type === 'pupil') {
         if (this.user.class.year < 11) {
            this.timeFrames = this.timeFrames.concat([timeFrames.sek1_7]);
         }
         else {
            this.timeFrames = this.timeFrames.concat(timeFrames.pm);
         }
      }
      else {
         this.timeFrames = this.timeFrames.concat(timeFrames.pm);
      }

      this.timeFrames.map(tf => {
         tf.normStart = (tf.start.length == 4 ? ('0' + tf.start) : tf.start);
         tf.normEnd   = (tf.end.length == 4 ? ('0' + tf.end) : tf.end);
      });

      for (let hour=0; hour<10; ++hour) {
         const elHour = this.table.createElement('div', 'timetable-cell hour-name');
         elHour.setStyles({
            gridArea: `${this.hourRows[hour+1]} / 1`
         });
         elHour.innerHTML = this.timeFrames[hour] ? `<div class="timeframe">${this.timeFrames[hour].start}</div><div class="hour">${hour+1}</div><div class="timeframe">${this.timeFrames[hour].end}</div>` : hour + 1;
      }

      for (let i of [2, 5, 8, 11]) {
         let elHour = this.table.createElement('div', 'timetable-cell hour-name');
         elHour.style.gridArea = `${i} / 1`;
         if ([5,8].includes(i)) elHour.innerHTML = '<div class="timeframe">Pause</div>';
      }

      for (let i=0; i<5; ++i) {
         for (let j=0; j<4; ++j) {
            let elBreak = this.table.createElement('div', `timetable-cell break sel-b-${i+1}-${j}`);
            elBreak.style.gridArea = `${this.breakRows[j]} / ${i+2} / span 1`;
         }
      }

      this.table.querySelectorAll('.hour-name').forEach(el => el.onclick = () => {
         new ModalSelectTimeFrame("Unterrichtszeiten auswählen", (type) => {
            this.dm.setTimeFrameType(type);
            this.loadTimetable(this.result);
         });
      });

      let cells = {};

      if (timetable) {
         for (const item of timetable) {
            if (!cells[item.weekday]) cells[item.weekday] = {};
            if (!cells[item.weekday][item.displayHour]) cells[item.weekday][item.displayHour] = [];
            cells[item.weekday][item.displayHour] = [...cells[item.weekday][item.displayHour], item];
            for (let i=1; i<item.displaySpan; ++i) {
               cells[item.weekday][item.displayHour+i] = false;
            }
         }
      }

      for (let hour=1; hour<=10; ++hour) {
         for (let weekday=1; weekday<6; ++weekday) {
            if (!cells.hasOwnProperty(weekday) || !cells[weekday].hasOwnProperty(hour)) {
               const elEmpty = this.table.createElement('div', 'timetable-cell empty sel-' + weekday + '-' + hour);
               elEmpty.style.gridArea = `${this.hourRows[hour]} / ${weekday+1} / span 1`;
            }
         }
      }

      if (timetable) {
         for (const weekday in cells) {
            for (let hour in cells[weekday]) {
               const items = cells[weekday][hour];
               if (items) {

                  const itemm = items[0];

                  let splitItems = [Object.assign({}, itemm)];
                  if ([2,4,6].includes(itemm.hour) && itemm.displaySpan > 1) {
                     splitItems.push(Object.assign({}, itemm));
                     splitItems[0].displaySpan = 1;
                     splitItems[1].displaySpan = 1;
                     splitItems[1].displayHour++;
                  }

                  for (let item of splitItems) {
                     const elItem = this.table.createElement('div', 'timetable-cell timetable-item');

                     if (parseInt(hour) > 6 && item.course && item.displaySpan == 1) {
                        if (this.user.type === 'teacher') {
                           const classes = item.course.classes.map(cls => { return this.dm.getClass(cls); });
                           if (classes.length && classes[0] && classes[0].year > 10 && (parseInt(hour)) % 2 !== (weekNumber % 2)) elItem.classList.add('inactive');
                        }
                        else {
                           if (this.user.class.year > 10 && (parseInt(hour)) % 2 !== (weekNumber % 2)) elItem.classList.add('inactive');
                        }
                     }

                     for (let i=0; i<item.displaySpan; ++i) {
                        elItem.classList.add('sel-' + weekday + '-' + (parseInt(hour)+i));
                     }

                     elItem.setStyles({
                        //gridArea: `${item.displayHour < 7 ? item.displayHour+1 : item.displayHour+2} / ${item.weekday+1} / span ${item.displaySpan}`,
                        gridArea: `${this.hourRows[item.displayHour]} / ${item.weekday+1} / span ${item.displaySpan}`
                     });

                     let teachers = [];
                     items.map(item => teachers = teachers.concat(item.teachers).unique());

                     if (result.type !== 'teacher' && teachers.includes(this.user.id)) {
                        elItem.classList.add('my');
                     }

                     if (result.type === 'teacher') {
                        let classNames = '';
                        if (item.course) {
                           const classes = item.course.classes.map(cls => { return this.dm.getClass(cls); });
                           classNames = this.user.type === 'teacher' ? groupClassNames(classes) : '';
                        }
                        elItem.innerHTML = `<div class="class">${classNames}</div> <div class="title">${item.title}</div> <div class="room">${item.rooms.map((id) => { return this.dm.getRoom(id).short; }).join(',')}</div>`;
                     }
                     else if (result.type === 'room') {
                        let classNames = '';
                        if (item.course) {
                           const classes = item.course.classes.map(cls => { return this.dm.getClass(cls); });
                           classNames = this.user.type === 'teacher' ? groupClassNames(classes) : '';
                        }
                        //const teachers = item.teachers.map((id) => this.dm.getUser(id).short).join(',');
                        const teacherShort = teachers.map((id) => this.dm.getUser(id).short).join(',');
                        elItem.innerHTML = `<div class="teachers">${teacherShort}</div> <div class="title">${item.title}</div> <div class="room">${classNames}</div>`;
                     }
                     else if (result.type === 'class') {
                        //const teachers = items.map(item => item.teachers.map((id) => this.dm.getUser(id).short).join(',')).join('|');
                        const teacherShort = teachers.map((id) => this.dm.getUser(id).short).join(',');
                        const title    = items.map(item => item.title).join('/');
                        const rooms     = items.map(item => item.rooms.map((id) => this.dm.getRoom(id).short).join(',')).join('|');
                        elItem.innerHTML = `<div class="teachers">${teacherShort}</div> <div class="title">${title}</div> <div class="room">${rooms}</div>`;
                     }
                     else {
                        const teacherShort = teachers.map((id) => this.dm.getUser(id).short).join(',');
                        elItem.innerHTML = `<div class="teachers">${teacherShort}</div> <div class="title">${item.title}</div> <div class="room">${item.rooms.map((id) => { return this.dm.getRoom(id).short; }).join(',')}</div>`;
                     }

                     elItem.onclick = () => {
                        new ModalShowTimetableItem(result.type, items, this.dm);
                     };
                  }

               }

            }
         }

         if (result.type === 'teacher') {
            this.dm.getWatchesByTeacher(result.id).then(watches => this.addWatches(watches));
         }

      }

   }

   addWatches(watches) {
      for (let watch of watches) {
         let elWatch = this.table.createElement('div', 'timetable-cell watch');
         elWatch.style.gridArea = `${this.breakRows[watch.position]} / ${watch.weekday+1} / span 1`
         elWatch.innerText = watch.name;
         elWatch.style.height = "1.6rem";
         elWatch.onclick = (event) => {
            event.stopPropagation();
            new ModalShowInfo("Aufsicht", '<p>'+watch.note+'</p>');
         }
      }
   }

   load(loadData) {

      if (loadData) {
         this.user = this.dm.getUserSelf();

         if (this.user.type === 'pupil') {
            this.tab.querySelector('.statusbar').setStyles({
               height: 0,
               padding: 0,
               overflow: 'hidden'
            })
            this.loadTimetable(this.user);
         }
         else if (this.user.type === 'teacher') {
            this.loadTimetable(this.user);
         }

         this.tab.setAttribute('loaded', '');

      }



   }

};
